import { apiAction } from "@ROM-utils/actions";
import NotificationsApi from "./api";

export const FETCH_NOTIFICATIONS = "companyRoles/api/FETCH_NOTIFICATIONS";

export function fetchNotifications() {
  return apiAction(FETCH_NOTIFICATIONS, NotificationsApi.fetchNotifications());
}
